import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Observable, TimeoutError, of } from 'rxjs';
import { catchError, map, take, timeout } from 'rxjs/operators';
import { AuthService } from '@services/auth.service';

// timeoutPath, quando informado, é usado se o stream de permissão não emitir a tempo —
// indica perfil ainda não carregado (não negação explícita) — redireciona ao home.
export function createRoleGuard(
  getSource: (auth: AuthService) => Observable<boolean>,
  options: { denyPath: string; timeoutPath?: string; timeoutMs?: number }
): CanActivateFn {
  return () => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const timeoutRedirect = options.timeoutPath ?? options.denyPath;
    const timeoutMs = options.timeoutMs ?? 5000;
    return getSource(authService).pipe(
      take(1),
      timeout(timeoutMs),
      map((ok) => (ok ? true : router.createUrlTree([options.denyPath]))),
      catchError((err) => {
        if (!(err instanceof TimeoutError)) {
          // TODO: substituir por LoggerService quando disponível
          console.error('[createRoleGuard] erro inesperado no stream de autorização:', err);
        }
        return of(
          err instanceof TimeoutError
            ? router.createUrlTree([timeoutRedirect])
            : router.createUrlTree([options.denyPath])
        );
      })
    );
  };
}
